// Route-template resolver for the user-action recorder (gurucloudai kanban
// b91c17bf): a recorded screen is '/portal/customers/:slug', never
// '/portal/customers/acme'. App.tsx declares the portal routes as JSX under
// <BrowserRouter>, which has no useMatches(), so the templates are listed
// here and matched with React Router's own matchRoutes (same ranking rules
// the router uses). Keep this list in step with the /portal routes in
// App.tsx; portalScreens.test.ts checks every template against a concrete
// path and the fallback masks ids on anything unlisted.

import { matchRoutes } from 'react-router-dom';

export const PORTAL_SCREENS: readonly string[] = [
  '/portal',
  '/portal/login',
  '/portal/inbox',
  '/portal/sent',
  '/portal/all-emails',
  '/portal/orders',
  '/portal/pricing-exemptions',
  '/portal/missed-orders',
  '/portal/customers',
  '/portal/customers/:slug',
  '/portal/analyst',
  '/portal/inbox-analytics',
  '/portal/knowledge-banks',
  '/portal/quality-copilot',
  '/portal/quality-copilot/cases',
  '/portal/quality-copilot/cases/:caseRef',
  '/portal/quality-copilot/threads/:threadRef',
  '/portal/quality-copilot/waiting',
  '/portal/quality-copilot/routed',
  '/portal/quality-copilot/done',
  '/portal/quality-copilot/briefs',
  '/portal/quality-copilot/briefs/constellations',
  '/portal/quality-copilot/briefs/digest',
  '/portal/quality-copilot/ask',
  '/portal/tech-support-copilot',
  '/portal/signals',
  '/portal/signals/constellations',
  '/portal/signals/digest',
  '/portal/roadmap',
  '/portal/my-roadmap',
  '/portal/meetings',
  '/portal/quality-issues',
  '/portal/customer-grading',
  '/portal/costs',
  '/portal/readout',
  '/portal/portal-analytics',
  '/portal/my-salespeople',
  '/portal/team',
  '/portal/analytics',
  '/portal/settings',
];

const ROUTE_OBJECTS = PORTAL_SCREENS.map((path) => ({ path }));

// Same shape as the library's own fallback (guru-recorder.js ID_SEGMENT):
// numbers, uuids / hex runs and long opaque tokens become ':id'. A long
// token only counts as an id when it contains a digit, so a hyphenated route
// word such as 'email-monitor-decisions' is kept.
const ID_SEGMENT = /^(\d+|[0-9a-f]{8,}(-[0-9a-f-]+)?|(?=[A-Za-z_-]*\d)[A-Za-z0-9_-]{20,})$/;

/** Strip query/hash and mask id-looking segments: /x/123 -> /x/:id */
export function maskPathIds(pathname: string): string {
  const path = (pathname || '/').split('?')[0].split('#')[0] || '/';
  return (
    path
      .split('/')
      .map((seg) => (seg && ID_SEGMENT.test(seg) ? ':id' : seg))
      .join('/') || '/'
  );
}

/**
 * The route template for a concrete pathname. Listed portal routes resolve
 * to their declared template; anything else falls back to the masked path.
 */
export function resolvePortalScreen(pathname: string): string {
  const path = (pathname || '/').split('?')[0].split('#')[0] || '/';
  const matches = matchRoutes(ROUTE_OBJECTS, path);
  if (matches && matches.length > 0) {
    const template = matches[matches.length - 1].route.path;
    if (template) return template;
  }
  return maskPathIds(path);
}
